<div class="dialog-shell" *ngIf="data.meeting as meeting">
  <div class="dialog-header">
    <div>
      <p class="eyebrow">Meeting Details</p>
      <h2>{{ meeting.title }}</h2>
      <p class="subtitle">{{ meeting.roomType }} room · {{ meeting.status }}</p>
    </div>
    <button mat-icon-button type="button" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <div class="dialog-section hero-strip">
      <div>
        <span>Starts</span>
        <strong>{{ meeting.startTime | date:'medium' }}</strong>
      </div>
      <div>
        <span>Ends</span>
        <strong>{{ meeting.endTime | date:'medium' }}</strong>
      </div>
      <div>
        <span>Room</span>
        <strong>{{ meeting.roomName }}</strong>
        <small>{{ meeting.roomCode }}</small>
      </div>
    </div>

    <div class="content-grid">
      <section class="dialog-section panel">
        <div class="section-heading">
          <strong>Agenda</strong>
          <small>Meeting purpose, organizer context, and room access.</small>
        </div>
        <p>{{ meeting.description || 'No meeting description provided.' }}</p>

        <div class="meta-list">
          <div>
            <span>Organizer</span>
            <strong>{{ meeting.createdByName || 'Unknown' }}</strong>
          </div>
          <div>
            <span>Join link</span>
            <a *ngIf="meeting.meetingLink; else noLink" [href]="meeting.meetingLink" target="_blank" rel="noopener">Open meeting link</a>
            <ng-template #noLink><strong>Internal room only</strong></ng-template>
          </div>
        </div>
      </section>

      <section class="dialog-section panel">
        <div class="section-heading">
          <strong>Attendees</strong>
          <small>{{ meeting.attendees?.length || 0 }} invited staff on this meeting.</small>
        </div>
        <div class="attendee-editor" *ngIf="meeting.isOrganizer">
          <button mat-stroked-button type="button" (click)="toggleAttendeeEdit()">
            {{ editingAttendees ? 'Cancel Edit' : 'Add / Remove Staff' }}
          </button>
        </div>
        <div class="attendee-edit-box" *ngIf="editingAttendees">
          <mat-form-field appearance="outline">
            <mat-label>Meeting attendees</mat-label>
            <mat-select multiple [(value)]="attendeeStaffIds">
              <mat-option *ngFor="let staff of data.staffOptions" [value]="staff.staffId">
                {{ staff.fullName }} <span *ngIf="staff.department">· {{ staff.department }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-flat-button color="primary" type="button" [disabled]="saving" (click)="saveAttendees()">Save Attendees</button>
        </div>
        <div class="attendee-list" *ngIf="meeting.attendees?.length; else noAttendees">
          <div class="attendee-row" *ngFor="let attendee of meeting.attendees">
            <div>
              <strong>{{ attendee.staffName }}</strong>
              <small>{{ attendee.email || 'No email' }}</small>
            </div>
            <span class="organizer-badge" *ngIf="attendee.isOrganizer">Organizer</span>
          </div>
        </div>
        <ng-template #noAttendees>
          <p class="muted">No attendees attached.</p>
        </ng-template>
      </section>
    </div>

    <section class="dialog-section panel">
      <div class="section-heading">
        <strong>Meeting Chat</strong>
        <small>Conversation sent during the meeting remains available here after the room ends.</small>
      </div>
      <div class="chat-history" *ngIf="!loadingChat && meeting.chatMessages?.length; else noMeetingChat">
        <div class="chat-row" *ngFor="let message of meeting.chatMessages">
          <div class="chat-meta">
            <strong>{{ message.createdByName }}</strong>
            <small>{{ message.createdAt | date:'medium' }}</small>
          </div>
          <p>{{ message.message }}</p>
        </div>
      </div>
      <ng-template #noMeetingChat>
        <p class="muted">{{ loadingChat ? 'Loading chat...' : 'No chat messages recorded for this meeting yet.' }}</p>
      </ng-template>
    </section>
  </div>

  <div class="dialog-actions">
    <button mat-flat-button color="primary" type="button" (click)="openLiveRoom()">Open Live Room</button>
    <button mat-stroked-button type="button" (click)="copyRoomCode()">Copy Room Code</button>
    <button mat-stroked-button type="button" *ngIf="meeting.isOrganizer" [disabled]="saving || meeting.status === 'Scheduled'" (click)="markStatus('Scheduled')">Mark Scheduled</button>
    <button mat-stroked-button color="primary" type="button" *ngIf="meeting.isOrganizer" [disabled]="saving || meeting.status === 'Completed'" (click)="markStatus('Completed')">Mark Completed</button>
    <button mat-stroked-button color="warn" type="button" *ngIf="meeting.isOrganizer" [disabled]="saving || meeting.status === 'Cancelled'" (click)="markStatus('Cancelled')">Cancel Meeting</button>
  </div>
</div>
